'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { AdWordsAdTypes } from 'AdsUI/lib/Constants';
import AdWordsTextAdReportingRecord from 'AdsUI/records/reporting/AdWordsTextAdReportingRecord';
import AdWordsTextAdPreview from 'AdsUI/components/campaign-reporting/AdWordsTextAdPreview';
import AdWordsGenericAdPreview from 'AdsUI/components/campaign-reporting/AdWordsGenericAdPreview';
import AdWordsLegacyAppAdReportingRecord from 'AdsUI/records/reporting/AdWordsLegacyAppAdReportingRecord';
import AdWordsGenericAdReportingRecord from 'AdsUI/records/reporting/AdWordsGenericAdReportingRecord';

const AdWordsReportingNameCell = ({
  entity
}) => {
  const AdPreview = entity.type === AdWordsAdTypes.SMART_CAMPAIGN_AD ? AdWordsTextAdPreview : AdWordsGenericAdPreview;
  return /*#__PURE__*/_jsx(AdPreview, {
    entity: entity
  });
};

AdWordsReportingNameCell.propTypes = {
  entity: PropTypes.oneOfType([PropTypes.instanceOf(AdWordsTextAdReportingRecord), PropTypes.instanceOf(AdWordsLegacyAppAdReportingRecord), PropTypes.instanceOf(AdWordsGenericAdReportingRecord)])
};
export default AdWordsReportingNameCell;